import Resource from './Resource'

class Regime extends Resource {
  static urlRoot() {
    return '/contracts/spain/regimes'
  }
}

export default Regime
